import { LoadableAfterPaint } from '@confluence/loadable';

export const LazyAIPlannerSyncByline = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AIPlannerSyncByline" */ './AIPlannerSyncByline.tsx'
			)
		).AIPlannerSyncByline,
	loading: () => null,
});
